/*
 * Carousel
 *   - Slides (.carousel__slide) + optional thumbnails + prev/next
 *   - Keyboard arrows when carousel is focus-within
 *   - Loops at ends
 */

function initOne(root) {
    if (root.dataset.wired === '1') return;
    root.dataset.wired = '1';

    const slides = Array.from(root.querySelectorAll('.carousel__slide'));
    const thumbs = Array.from(root.querySelectorAll('.carousel__thumb button'));
    const prev   = root.querySelector('.js-carousel-prev');
    const next   = root.querySelector('.js-carousel-next');
    if (!slides.length) return;

    let index = 0;

    const setActive = (i) => {
        index = (i + slides.length) % slides.length;
        slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
        root.querySelectorAll('.carousel__thumb').forEach((t, n) => t.classList.toggle('is-active', n === index));
    };

    prev && prev.addEventListener('click', () => setActive(index - 1));
    next && next.addEventListener('click', () => setActive(index + 1));

    thumbs.forEach((btn) => {
        btn.addEventListener('click', () => {
            const i = parseInt(btn.dataset.index, 10) || 0;
            setActive(i);
        });
    });

    root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); setActive(index - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); setActive(index + 1); }
    });
}

export function initCarousels() {
    document.querySelectorAll('.js-carousel').forEach(initOne);
}
